import React from 'react';
import { PageWrapper } from '../../components/common';
import AltaPadron from '../../components/padron/AltaPadron';

const AltaPadronPage: React.FC = () => {
  return (
    <PageWrapper>
      <AltaPadron />
    </PageWrapper>
  );
};

export default AltaPadronPage;    